<template>
  <div>
    <Breadcrumbs
      :title="
        isEdit ? `Edit Category: ${category?.title || ''}` : 'Create Category'
      "
    />

    <Card1
      colClass="col-sm-12"
      cardhaderClass="pb-0 title-header"
      :title="isEdit ? 'Edit Knowledge Category' : 'Create Knowledge Category'"
    >
      <div class="row">
        <div class="col-md-12">
          <!-- Navigation -->
          <div class="mb-3">
            <router-link
              to="/knowledge-categories"
              class="btn btn-outline-secondary"
            >
              <i class="fa fa-arrow-left me-2"></i>Back to Categories
            </router-link>
          </div>

          <!-- Category Form -->
          <BlogCategoryForm
            :category="category"
            :is-edit="isEdit"
            :loading="loading"
            @save="handleSave"
            @cancel="handleCancel"
          />
        </div>
      </div>
    </Card1>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, defineAsyncComponent } from "vue";
import { useRoute, useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import apiService from "@/services/apiService";

const Card1 = defineAsyncComponent(
  () => import("@/components/commen/card/cardData1.vue")
);

const BlogCategoryForm = defineAsyncComponent(
  () => import("@/components/theme/admin/knowlege/BlogCategoryForm.vue")
);

const route = useRoute();
const router = useRouter();

// State
const category = ref<any>(null);
const loading = ref(false);
const isEdit = ref(false);

// Methods
const fetchCategory = async (id: string) => {
  try {
    loading.value = true;
    category.value = await apiService.getKnowledgeCategoryById(id);
  } catch (error) {
    console.error("Error fetching category:", error);
    toast.error("Failed to load category");
    router.push("/admin/knowlege-categories");
  } finally {
    loading.value = false;
  }
};

const handleSave = async (categoryData: any) => {
  try {
    loading.value = true;

    if (isEdit.value && route.params.id) {
      await apiService.updateKnowledgeCategory(
        route.params.id as string,
        categoryData
      );
      toast.success("Category updated successfully");
    } else {
      await apiService.createKnowledgeCategory(categoryData);
      toast.success("Category created successfully");
    }

    router.push("/admin/knowlege-categories");
  } catch (error: any) {
    console.error("Error saving category:", error);
    toast.error(error.response?.data?.message || "Failed to save category");
  } finally {
    loading.value = false;
  }
};

const handleCancel = () => {
  router.push("/admin/knowlege-categories");
};

// Lifecycle
onMounted(async () => {
  const categoryId = route.params.id as string;

  if (categoryId && categoryId !== "new") {
    isEdit.value = true;
    await fetchCategory(categoryId);
  }
});
</script>

<style scoped>
/* Add any specific styles for the edit page */
</style>
